module.exports = __webpack_public_path__ + "static/media/mn.60217659.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mn.svg
// module id = 2157
// module chunks = 0